const normalizeCallEmail = (value: string): string =>
  value.trim().toLowerCase();

export function callsIncomingChannel(
  email: string,
): string {
  return `kinscircle-incoming-call:${normalizeCallEmail(email)}`;
}
